import { render, staticRenderFns } from "./comp_CheckoutStep-confirm--active.vue?vue&type=template&id=5b2123a1&scoped=true&"
import script from "./comp_CheckoutStep-confirm--active.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-confirm--active.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-confirm--active.vue?vue&type=style&index=0&id=5b2123a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2123a1",
  null
  
)

export default component.exports